import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "detection-per-engine",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Compare detection activity across protection engines.",
    domain: "detections",
    visual: "Ranked bars",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "chart" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
